import 'rc-tooltip/assets/bootstrap.css';
import React, { lazy, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import InfoStyle from './style';

const layout = window?.$environment?.CURRENT_LAYOUT;

const Label = lazy(() => import(`globalcomponents/UI/Label/${layout}`));
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

const InfoCard = ({ fleetIconMapping, companyName, totalCount }) => {
  const { t } = useTranslation();

  const translations = useMemo(
    () => ({
      total: t('scorecard.total'),
      vehicle: t('scorecard.vehicle'),
    }),
    [t]
  );

  const iconValue = fleetIconMapping?.infoTruck || mediaUrls.bobTail;

  return (
    <InfoStyle>
      <Label className="text">{companyName}</Label>
      <div className="content">
        <Label className="count">{totalCount}</Label>
        <div>
          <Label className="label">{translations.total}</Label>
          <Label className="label">{translations.vehicle}</Label>
        </div>
        <SvgIcon value={iconValue} />
      </div>
    </InfoStyle>
  );
};

InfoCard.propTypes = {
  fleetIconMapping: PropTypes.object.isRequired,
  companyName: PropTypes.string,
  totalCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

InfoCard.defaultProps = {
  companyName: '',
  totalCount: '0',
};

export default InfoCard;
